import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { applicationHistory } from '../../common/application-history';



import {
    saveArrangedAlbumItems, stopResort, cancelResort,
    startResort
} from '../../assetContainer/actions/asset-container-actions';

class AssetArrangeModeHeader extends PureComponent {
    constructor(props) {
        super(props);
        this.cancelSelection = this.cancelSelection.bind(this);
 
        this.saveSortedAssets = this.saveSortedAssets.bind(this);
        this.props.startResort(this.props.albumItems);

    }
    cancelSelection() {
        this.props.stopResort();
        this.props.cancelResort(this.props.originalValues);
        applicationHistory.goBack();
    }

    saveSortedAssets(){
        let req = [];
        for(let i=0;i<this.props.albumItems.length;i++){
            if(this.props.albumItems[i].modified === true){
                req.push({id:this.props.albumItems[i].id,displayOrder:this.props.albumItems[i].displayOrder});
            }
        }
        this.props.saveArrangedAlbumItems(req);
        this.props.stopResort();
        applicationHistory.goBack();
    }

   render() {
        

        return (
            <header className="header-arrange-mode header-flex-container">
                <div className="header-flex-left">
                    <div className="header-item header-item-left" onClick={this.cancelSelection}>
                        <div className="header-icon cancel" />
                        <span className="cancel-text">Cancel</span>
                    </div>

                </div>
                <div className="header-flex-right">
                    <div className="header-item header-item-right" onClick={this.saveSortedAssets}>
                        <div className="header-icon save-white" />
                        <div className="header-label">Save</div>
                    </div>
                </div>

            </header>
        );
    }
}

AssetArrangeModeHeader.propTypes = {
   
    albumItems: PropTypes.array,
    saveArrangedAlbumItems: PropTypes.func,
    stopResort: PropTypes.func,
    originalValues: PropTypes.array,
    cancelResort: PropTypes.func
};

const mapStateToProps = state => {
    return {
        albumItems: state.albumItems.albumItems,
        originalValues: state.assetContainer.originalValues
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveArrangedAlbumItems: results => dispatch(saveArrangedAlbumItems(dispatch, results)),
        stopResort: () => dispatch(stopResort()),
        cancelResort: (originalValues) => dispatch(cancelResort(originalValues)),
        startResort: (originalValues) => dispatch(startResort(originalValues)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetArrangeModeHeader);



// WEBPACK FOOTER //
// ./src/header/components/album-item-arrange-mode-header.jsx